import { render, staticRenderFns } from "./ContactTypes.vue?vue&type=template&id=8839335e&"
import script from "./ContactTypes.vue?vue&type=script&lang=js&"
export * from "./ContactTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports